import { InnerFilledCard } from "./FilledCard.js";
import { OutlinedCard } from "./OutlinedCard.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/card/SelectionCard.tsx
const SelectionCard = ({ children, color, isSelected, ...rest }) => {
	if (isSelected) return /* @__PURE__ */ jsx(InnerFilledCard, {
		withBorder: true,
		withOutline: true,
		color,
		...rest,
		children
	});
	return /* @__PURE__ */ jsx(OutlinedCard, {
		iconColor: "gray",
		...rest,
		children
	});
};

//#endregion
export { SelectionCard };